<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1018434" style="color: #82a339"><b>SWEET AND SPICY NUTS</b></p>
<p class="ext" id="d7e1018934"><b><i>Packaged in pretty jars or cellophane bags, these treats are a perfect hostess gift.</i></b></p>
<p class="h4" id="d7e1019934" style="color: #496210"><b>Prep: 15 minutes plus cooling <br/> Bake: 25 minutes</b></p>
<p class="ul" id="d7e1020734">1 cup sugar</p>
<p class="ul" id="d7e1021034">2 teaspoons salt</p>
<p class="ul" id="d7e1021334">1 teaspoon ground cumin</p>
<p class="ul" id="d7e1021634">1 teaspoon ground cinnamon</p>
<p class="ul" id="d7e1021934">1 teaspoon coarsely ground black pepper</p>
<p class="ul" id="d7e1022234">½ teaspoon ground red pepper (cayenne)</p>
<p class="ul" id="d7e1023234">1 large egg white</p>
<p class="ul" id="d7e1023534">6 cups raw unsalted nuts, such as walnuts, pecans, <br/> natural almonds, and/or cashews</p>
<p class="pub" id="d7e1024334" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat oven to 325°F. Grease two 15½" by 10½" jelly-roll pans.</p>
<p class="pub" id="d7e1027034"><span style="color: #c15b49"><b>2.</b></span> In small bowl, combine sugar, salt, cumin, cinnamon, black pepper, and red pepper; stir until blended. In large bowl, with wire whisk, beat egg white until foamy. Add nuts to egg white; stir to coat evenly. Add sugar mixture; toss until nuts are thoroughly coated.</p>
<p class="pub" id="d7e1029234"><span style="color: #c15b49"><b>3.</b></span> Divide nut mixture between prepared jelly-roll pans, spreading evenly. Bake, stirring twice during baking, until golden brown and dry, 25 to 27 minutes. With slotted spoon, transfer nuts to waxed paper; spread in single layer. Cool. Store in airtight container at room temperature up to 1 month. Makes about 8 cups.</p>
<p class="ntx" id="d7e1032134">Each ¼ cup: About 165 calories, 4g protein, 11g carbohydrate, 12g total fat (2g saturated), 0mg cholesterol, 150mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c19_r1.vue?1b7cddb3